import $ from '@rover/globals/jquery';
import Url from '@rover/globals/domurl';
import Mustache from '@rover/globals/Mustache';
import Rover from '@rover/globals/Rover';
import dataLayer from '@rover/globals/dataLayer';
import inject from '@rover/utilities/injector';
// eslint-disable-next-line no-unused-vars
import auth from '@rover/utilities/auth'; // This is used below as Rover.utils.logout, don't remove
import currentUser from '@rover/globals/currentUser';

import PerformanceFeedbackMetricsGlanceView from './backbone/views/performance_feedback_metrics_glanceview';

const showReactNotificationsCenter = inject(
  'Rover.context.header.showReactNotificationsCenter',
  false
);

export default {
  renderAuthenticatedHeader() {
    const { isSitter } = currentUser;
    const supportsReferral = inject('Rover.context.supportsReferral');

    /* eslint-disable no-param-reassign */
    const truncateWithEllipsis = (string, maxLength) => {
      const ellipsis = '...';
      if (string.length > maxLength) {
        const truncateTo = maxLength - ellipsis.length;
        string = string.slice(0, truncateTo) + ellipsis;
      }
      return string;
    };
    /* eslint-enable no-param-reassign */

    const appendURLRef = (url, ref = 'header') => {
      /* TODO: Use internal URL handling */
      const u = new Url(url);
      u.query.ref = ref;
      return u.toString();
    };

    const headerContext = {
      isSitter,
      firstName: truncateWithEllipsis(currentUser.firstName, 12),
      smallPhotoUrl: currentUser.smallPhotoUrl,
      unreadMessageCount: currentUser.unreadMessageCount,
      performanceMetricsEnabled: currentUser.performanceMetricsEnabled,

      // Used by referral bottom row on mobile menu
      // See logged_in_user.mustache
      staticSvgPresent: Rover.context.staticSvgPresent,
      urlReferAFriend: appendURLRef(Rover.urls.referAFriend, 'header-menu'),

      urlOverview: appendURLRef(Rover.urls.overview),
      urlDashboard: appendURLRef(Rover.urls.dashboard),
      urlProfile: appendURLRef(Rover.urls.profile),
      urlInbox: appendURLRef(Rover.urls.inbox),
      urlCalendar: appendURLRef(Rover.urls.calendar),
      // eslint-disable-next-line no-script-url
      urlLogout: 'javascript:Rover.utils.logout("header")',
      urlDogPhotos: appendURLRef(Rover.urls.dogPhotos),
      urlRebook: appendURLRef(Rover.urls.rebook),
      urlHelp: appendURLRef(Rover.urls.help),

      hasDog: currentUser.hasDogs,

      showReferralLink: !isSitter && supportsReferral,

      showReactNotificationsCenter,
    };
    if (Rover.urls.settings) {
      headerContext.urlNotifications = appendURLRef(Rover.urls.settings);
    }
    const rendered = Mustache.template('new_design/header/logged_in_user').render(headerContext);

    if (!isSitter) {
      $('.js-become-a-sitter').removeClass('hide');
      $('.js-give-twenty-get-twenty').removeClass('hide');
    } else if (!currentUser.listsAllServices) {
      $('.js-list-more-services').removeClass('hide');
    }
    if (isSitter) {
      $('.js-invite-a-friend').removeClass('hide');
    }
    const $anonymousHeader = $('.js-anonymous-header');

    $anonymousHeader.html(rendered);

    if (showReactNotificationsCenter) {
      // Import here so we know the react-notifications-center div
      // has been rendered from the moustache template
      import('@rover/react-lib/pages/header/NotificationsCenter');
    }

    Rover.utils.initGAEvents($anonymousHeader);

    // eslint-disable-next-line no-unused-vars
    const perfView = new PerformanceFeedbackMetricsGlanceView({
      performanceMetricsEnabled: currentUser.performanceMetricsEnabled,
    });

    // If referral is not supported in country configuration, hide referral link in header.
    // Also this code depends on the fact that Authenticated.init() comes later than
    // Auth.init() in js/application.js initialization code.
    if (!supportsReferral) {
      $('.js-header-referral').addClass('hide');
    }
  },

  showHaveDogPrompt() {
    if (currentUser.shouldPromptForPets && !$.cookie('have_dog_prompt')) {
      $('.js-have-dog-prompt')
        .modal('show')
        .on('hide.bs.modal', this.supressHaveDogPrompt);
    }
  },

  supressHaveDogPrompt() {
    $.cookie('have_dog_prompt', true, { expires: 3, path: '/' });
  },

  confirmNoDogs() {
    $.ajax(Rover.urls.hasDogs, {
      type: 'POST',
      data: {
        does_not_have_dogs: true,
      },
      success() {
        $('.js-have-dog-prompt .js-prompt').addClass('hidden');
        $('.js-have-dog-prompt .js-thanks').removeClass('hidden');
        window.setTimeout(() => {
          $('.js-have-dog-prompt').modal('hide');
        }, 3000);
      },
    });
  },

  confirmHasDogs() {
    this.suppressHaveDogPrompt();
    return true;
  },

  /* Datalayer Event tracking methods */
  trackAppDownloadLinkClick(e) {
    const app = $(e.currentTarget).attr('data-which');
    const where = $(e.currentTarget).attr('data-where');
    if (where === 'conversation') {
      dataLayer.push({ event: 'conversation-app-download-clicked', app });
    }
  },

  trackNavDropdownClick() {
    if (currentUser.performanceMetricsEnabled) {
      dataLayer.push({
        event: 'sitterscores-glance-view-scores-displayed',
        origin: 'main-menu',
      });
    }
  },

  addBindings() {
    $('.js-app-download-link').on('click', this.trackAppDownloadLinkClick);
    $('.js-authenticated-header').on('shown.bs.dropdown', this.trackNavDropdownClick);
    $('.js-no-dog-link').on('click', this.confirmNoDogs);
    $('.js-has-dog-link').on('click', this.confirmHasDogs);
  },

  subInit() {
    this.addBindings();
    this.renderAuthenticatedHeader();
    this.showHaveDogPrompt();
  },

  init() {
    currentUser
      .waitForAuthenticatedUserLoaded()
      .then(() => this.subInit())
      .catch(() => {});
  },
};



// WEBPACK FOOTER //
// ./js/Authenticated.js